<div class="container py-4">
  <h2 class="mb-3">Categorías</h2>
  <div class="row g-3 mb-4">
    <div class="col-6 col-md-4 col-lg-3" *ngFor="let c of cats">
      <app-category-tile [c]="c"></app-category-tile>
    </div>
  </div>

  <h3 class="mb-3">Destacados</h3>
  <div class="row g-3">
    <div class="col-6 col-md-4 col-lg-3" *ngFor="let p of destacados">
      <app-product-card [p]="p"></app-product-card>
    </div>
  </div>
</div>
